export const LoadingImage = () => {
  return (
    <div className='loading w-full h-80 rounded-md'></div>
  )
}
